import React from 'react';
import { isCritical } from '../lib/filters';

interface IssueIconProps {
  type: string | undefined;
  resolveByTime: string | undefined;
}

const IssueIcon: React.FC<IssueIconProps> = ({ type, resolveByTime }) => {
  let title: string | undefined, iconType: string | undefined, color: string | undefined;

  if (type) {
    switch (type.toLowerCase()) {
      case 'cancellation':
        title = 'Cancellation';
        iconType = 'cancelled';
        break;
      case 'diverted':
        title = 'Diversion';
        iconType = 'diverted';
        break;
      case 'threatened_connection':
        title = 'Connection';
        iconType = 'connection';
        break;
      case 'late_departure':
        title = 'Departure Delay';
        iconType = 'mindelay';
        break;
      case 'late_arrival':
        title = 'Arrival Delay';
        iconType = 'mindelay';
        break;
      case 'invalid_itinerary':
        title = 'Invalid Itinerary';
        iconType = 'unknown';
        break;
      case 'generic':
        title = 'Unknown';
        iconType = 'unknown';
        break;
      default:
        title = 'Unknown';
        iconType = 'unknown';
        break;
    }
  }

  if (title && iconType && resolveByTime) {
    color = isCritical(resolveByTime) ? 'color' : 'gray';
  } else if (type?.toLowerCase() === 'invalid_itinerary') {
    color = 'color';
  }

  return (
    <div
      className={`sprites sprite-${iconType}-${color}-32`}
      title={title}
    />
  );
};

export default IssueIcon;